/**
 * sl-yphr.13: ElsterService
 *
 * Tracks the currently active ELSTER block for sidebar panel rendering.
 * Pattern: Same as AutomationService.activeBlockId$
 */

import { LiveData, Service } from '@toeverything/infra';

export class ElsterService extends Service {
  /** Currently selected ELSTER block ID (null = no selection) */
  readonly activeBlockId$ = new LiveData<string | null>(null);

  setActiveBlock(blockId: string | null): void {
    this.activeBlockId$.next(blockId);
  }
}
